import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'common/Modal';

const withModal = WrappedComponent => class extends Component {
  static propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
  }

  render() {
    const { isModalOpen } = this.props;
    return (
      <Modal
        isOpen={isModalOpen}
        className="tc flex justify-center items-center h-100"
      >
        <WrappedComponent {...this.props} />
      </Modal>
    );
  }
};

export default withModal;
